<template>
  <div v-loading="loading" class="nx-page meterenergy-analysis">
    <el-card shadow="never">
      <div slot="header" class="card-head">
        <span>全厂能源用量结构（抄表）</span>
        <div class="filters">
          <el-date-picker v-model="billingMonth" type="month" value-format="yyyyMM" clearable size="small" style="width: 150px" />
          <el-button type="primary" size="small" @click="load">查询</el-button>
        </div>
      </div>
      <el-row :gutter="16">
        <el-col :md="12" :xs="24">
          <div ref="chartBar" class="chart-box" />
        </el-col>
        <el-col :md="12" :xs="24">
          <div ref="chartPie" class="chart-box" />
        </el-col>
      </el-row>
      <div class="chart-title mt16">电 · 近 6 月（kWh）</div>
      <div ref="chartE" class="chart-box" />
      <div class="chart-title mt16">水 · 近 6 月（m³）</div>
      <div ref="chartW" class="chart-box" />
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { fetchUsageStructure } from './api'

export default {
  name: 'MeterEnergyUsageStructure',
  data() {
    return { loading: false, billingMonth: null, data: {}, charts: [] }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    this.charts.forEach((c) => c.dispose())
  },
  methods: {
    resize() {
      this.charts.forEach((c) => c.resize())
    },
    async load() {
      this.loading = true
      try {
        const res = await fetchUsageStructure({ billingMonth: this.billingMonth || undefined })
        this.data = (res.data && res.data.data) || {}
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    renderCharts() {
      this.charts.forEach((c) => c.dispose())
      this.charts = []
      const d = this.data
      const bars = d.feeBars || []
      const hBar = echarts.init(this.$refs.chartBar)
      hBar.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 56, right: 24, top: 16, bottom: 28 },
        xAxis: { type: 'value' },
        yAxis: { type: 'category', data: bars.map((x) => x.feeLabel) },
        series: [{ type: 'bar', data: bars.map((x) => Number(x.usageAmount) || 0), itemStyle: { color: (p) => ['#f97316', '#0ea5e9', '#ef4444', '#64748b'][p.dataIndex] } }]
      })
      this.charts.push(hBar)

      const pie = echarts.init(this.$refs.chartPie)
      const share = d.structureSharePercent || []
      pie.setOption({
        tooltip: { trigger: 'item' },
        series: [{ type: 'pie', radius: '65%', data: share.map((x) => ({ name: x.name, value: Number(x.value) || 0 })), label: { formatter: '{b}\n{d}%' } }]
      })
      this.charts.push(pie)

      const em = d.electricMonthly || []
      const e = echarts.init(this.$refs.chartE)
      e.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 48, right: 16, top: 16, bottom: 28 },
        xAxis: { type: 'category', data: em.map((x) => x.billingMonth) },
        yAxis: { type: 'value', name: 'kWh' },
        series: [{ type: 'line', smooth: true, data: em.map((x) => Number(x.usageAmount) || 0), areaStyle: { color: 'rgba(249,115,22,0.12)' }, lineStyle: { color: '#ea580c' } }]
      })
      this.charts.push(e)

      const wm = d.waterMonthly || []
      const w = echarts.init(this.$refs.chartW)
      w.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 48, right: 16, top: 16, bottom: 28 },
        xAxis: { type: 'category', data: wm.map((x) => x.billingMonth) },
        yAxis: { type: 'value', name: 'm³' },
        series: [{ type: 'line', smooth: true, data: wm.map((x) => Number(x.usageAmount) || 0), areaStyle: { color: 'rgba(14,165,233,0.12)' }, lineStyle: { color: '#0284c7' } }]
      })
      this.charts.push(w)
    }
  }
}
</script>

<style scoped>
.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.filters {
  display: flex;
  gap: 8px;
  align-items: center;
}
.mb12 {
  margin-bottom: 12px;
}
.mt16 {
  margin-top: 16px;
}
.chart-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.chart-box {
  height: 280px;
  width: 100%;
}
</style>
